import { render, staticRenderFns } from "./ExtendCartTimerModal.vue?vue&type=template&id=574d867c&"
import script from "./ExtendCartTimerModal.vue?vue&type=script&lang=ts&"
export * from "./ExtendCartTimerModal.vue?vue&type=script&lang=ts&"
import style0 from "./ExtendCartTimerModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports